import { dateFormat, formatDateRange } from '@fullstory/util/date';
import React from 'react';

interface PointInTime {
  date: Date;
  startDate?: never;
  endDate?: never;
  alwaysShowTime?: never;
}

interface TimeRange {
  date?: never;
  startDate: Date;
  endDate: Date;
  alwaysShowTime?: boolean;
}

type TimeProps = PointInTime | TimeRange;

/**
 * React component version of the formatDateRange utility for easy rendering
 */
export const TimeDisplay = (props: TimeProps) => (
  <>{props.date ? dateFormat(props.date, { format: 'abbreviated' }) : formatDateRange(props)}</>
);
